module.exports = __webpack_public_path__ + "static/power_of_adaptive_training-112de8b3bb2dd5633dbe1e98be41d038.jpg";